module.exports = __webpack_public_path__ + "assets/img/yuyue-girl1.9909f502.png";